module.exports = __webpack_public_path__ + "media/images/athletes/115-392e3097504807471297cc986f3722a9.png";